import React from "react";
import validator from "validator";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loader from "../../Loader";
import * as actionTypes from "../../../../store/actions/actionTypes";
import { openAPI } from "../../../../config";

class ClaimProfile extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      first_name: "",
      last_name: "",
      company_name: "",
      phone: "",
      error: false,
      info: "",
      showContent: -1,
      isLoader: false,
    };
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.claimProfile = this.claimProfile.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onChangeHandler = name => event => {
    event.persist();
    if (event.target.value.trim().length === 0) {
      if (this._isMounted) {
        this.setState({
          error: true,
          info: "Field cannot be blank",
          [name]: "",
        });
      }
    } else {
      if (this._isMounted) {
        this.setState({
          [name]: event.target.value,
          error: false,
          info: "",
        });
      }
    }
  };

  validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  claimProfile = () => {
    if (this._isMounted) {
      this.setState({ isLoader: true });
    }
    if (!this.validateEmail(this.state.email)) {
      alert("Invalid Email Id");
      this.setState({ isLoader: false });
      return;
    }
    if (
      !this.state.error &&
      Boolean(this.state.first_name) &&
      Boolean(this.state.last_name) &&
      Boolean(this.state.company_name) &&
      Boolean(this.state.phone) &&
      Boolean(this.state.email)
    ) {
      openAPI
        .post(
          `${process.env.REACT_APP_API_URL}/upgrade-profile-request`,
          {
            email: this.state.email,
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            company_name: this.state.company_name,
            phone: this.state.phone,
          },
          {
            withCredentials: true,
          }
        )
        .then(response => {
          if (response.data.success) {
            if (this._isMounted) {
              this.setState({
                isLoader: false,
                success: true,
                info: "Thank you and a service specialist will be in touch soon.",
                email: "",
                first_name: "",
                last_name: "",
                company_name: "",
                phone: "",
                error: false,
                showContent: response.data.success,
              });
            }
          } else {
            const errors = Object.keys(response.data.error).map(
              err =>
                `${err.charAt(0).toUpperCase()}${err.slice(1)} : ${
                  response.data.message[err][0]
                }`
            );
            if (this._isMounted) {
              this.setState({
                isLoader: false,
                success: true,
                info: errors.join("\n"),
                email: "",
                first_name: "",
                last_name: "",
                company_name: "",
                phone: "",
                error: false,
                showContent: response.data.success,
              });
            }
          }
        });
    } else {
      if (this._isMounted) {
        this.setState({
          error: true,
          info: "Field cannot be blank",
          isLoader: false,
        });
      }
    }
  };

  resetForm = () => {
    if (this._isMounted) {
      this.setState({
        success: true,
        info: "",
        email: "",
        first_name: "",
        last_name: "",
        company_name: "",
        phone: "",
        error: false,
        showContent: -1,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <section
          className="overlay_popup footerPopup upgradeProfile"
          aria-hidden="false"
        >
          <div className="popBox">
            <a
              href="#close popup"
              className="close-overlay"
              onClick={e => {
                e.preventDefault();
                this.props.setClaimProfilePopUpFalse();
              }}
            ></a>
            <div className="popup_overlay_screen">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="footerFormContent">
                    <div className="left_section">
                      <div className="logo">
                        <img src="/images/logo_white.webp" />
                      </div>

                      <h1>Upgrade Your Profile</h1>
                      <p>
                        Let potential prospects find you on the world’s only
                        customer reference platform for B2B solutions &
                        services.
                      </p>
                      <p>
                        Contact us today to take control of your profile for
                        FREE and learn about our upgraded profile options to
                        unlock all of your customer references for prospects to
                        see.
                      </p>
                    </div>

                    <div className="right_section">
                      <>
                        {this.state.showContent === -1 && (
                          <div className="form">
                            <form>
                              <label className="fName">
                                First Name *
                                <input
                                  type="text"
                                  placeholder="John"
                                  value={this.state.first_name}
                                  onChange={this.onChangeHandler("first_name")}
                                />
                              </label>
                              <label className="lName">
                                Last Name *
                                <input
                                  type="text"
                                  placeholder="Doe"
                                  value={this.state.last_name}
                                  onChange={this.onChangeHandler("last_name")}
                                />
                              </label>
                              <label>
                                Your Company *
                                <input
                                  type="text"
                                  placeholder="Company Name"
                                  value={this.state.company_name}
                                  onChange={this.onChangeHandler(
                                    "company_name"
                                  )}
                                />
                              </label>
                              <label>
                                Your Email *
                                <input
                                  type="email"
                                  placeholder="Email"
                                  value={this.state.email}
                                  onChange={this.onChangeHandler("email")}
                                  onBlur={e => {
                                    e.persist();
                                    if (
                                      !validator.isEmail(e.target.value) &&
                                      this._isMounted
                                    ) {
                                      this.setState({
                                        error: true,
                                        info: "Invalid email format",
                                      });
                                    }
                                  }}
                                />
                              </label>
                              <label>
                                Phone Number *
                                <input
                                  type="tel"
                                  placeholder="(555) 555-5555"
                                  value={this.state.phone}
                                  onChange={
                                    //this.onChangeHandler("phone")
                                    e => {
                                      e.persist();
                                      if (!isNaN(e.target.value)) {
                                        this.setState({
                                          phone: e.target.value,
                                        });
                                      }
                                    }
                                  }
                                />
                              </label>
                              <button
                                onClick={e => {
                                  e.preventDefault();
                                  this.claimProfile();
                                }}
                                className="submit"
                              >
                                Upgrade Profile
                              </button>
                            </form>
                          </div>
                        )}
                        <div
                          class="clsMsg"
                          style={
                            Number(this.state.showContent) === -1
                              ? { display: "none" }
                              : { display: "block" }
                          }
                        >
                          <div
                            class="msg_block"
                            style={
                              Number(this.state.showContent) === 1
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <i class="fa fa-check" aria-hidden="true"></i>
                            <div class="textBlock">
                              <h3>Thanks for Contacting Us</h3>
                              <p>Our team will contact you soon.</p>
                            </div>
                          </div>
                          <div
                            class="msg_block"
                            style={
                              Number(this.state.showContent) === 0
                                ? { display: "block" }
                                : { display: "none" }
                            }
                          >
                            <i
                              class="fa fa-exclamation-triangle"
                              aria-hidden="true"
                            ></i>
                            <div class="textBlock">
                              <h3>Form could not be submitted</h3>
                              <p>There was an error, please try again.</p>
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {this.state.isLoader ? <Loader /> : null}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setClaimProfileToFalse: () => {
      dispatch({ type: actionTypes.UPDATE_CLAIM_PROFILE_FALSE });
    },
  };
};

const WithRouterClaimProfile = withRouter(ClaimProfile);
export default connect(null, mapDispatchToProps)(WithRouterClaimProfile);
